import type { ImageBlockProps } from '../types';
import { theme } from '../theme';

/** Pure image/figure block. */
export function ImageBlock({ url, alt, caption, width, height }: ImageBlockProps) {
  return (
    <figure className="mx-auto max-w-4xl px-6 py-8">
      <img src={url} alt={alt} width={width} height={height} loading="lazy" decoding="async" className="w-full rounded-lg object-cover" />
      {caption ? <figcaption className="mt-2 text-center text-sm" style={{ color: theme.textMuted }}>{caption}</figcaption> : null}
    </figure>
  );
}
